import {
    AlertTypes,
    apiClient,
    BaseGenericItemsStore,
    datagridCustomColumn,
    GenericItemsForm,
    GenericItemsUtils,
    IGetAllParams,
    setAlert,
    Paper,
    IconButton,
    MuiIcons
} from "@leap4/frontend";
import type { GridRenderCellParams } from "@leap4/frontend";
import {ITask} from "../../../interfaces/ITask";
import {urlsService} from "../../Routing/urlsService";
import React from 'react';

const {HomeOutlined, PlayCircleOutline: PlayCircleOutlineIcon} = MuiIcons;


const fields = {name:1, type:1,status:1,errorCount:1,cronExpression:1,lastRun:1,nextRun:1,isActive:1}

const getParams: IGetAllParams = {
    fields
}

let columns: datagridCustomColumn[];
let store: BaseGenericItemsStore<ITask & {_id: string, isActive: boolean}>


const  renderStatus = (params: GridRenderCellParams) => {
    const status = params.value;

    let color = "green"; // completed
    if (status === "failed") color = "red";
    else if (status === "running") color = "orange";
    return <strong style={{color, textTransform: "capitalize"}}>{params.value}</strong>;
};

const runTask = (params: GridRenderCellParams) => {
    return <IconButton aria-label="fingerprint" color="success" onClick={() => {activateTask(params.id)}}><PlayCircleOutlineIcon /></IconButton>
};

const activateTask = (id: string | number) => {
    (async () => {
        try {
            const baseUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/task/run/${id}`;
            await apiClient.get(baseUrl)
        } catch (err) {
            setAlert({msg: "Could not activate the task", type: AlertTypes.FAILURE})
        } finally {

        }
    })()
};

function setStoreAndColumns(){
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: process.env.REACT_APP_BACKEND_BASE_URL+'/api/task' || "",
    }, fields, {name: {editLinkFunc: urlsService.editTask}, isActive: {}, updated: {}, created: {}}
    )

    store = storeAndColumns.store;
    columns = storeAndColumns.columns;

    const runColumnObj: datagridCustomColumn = {
        align: "left",
        editable: false,
        field: "run",
        headerAlign: "left",
        headerName: "RUN",
        sortable: false,
        width: 55
    }

    columns.push(runColumnObj)
    columns.find(x=> x.field === "isActive")!.width = 65
    columns.find(x=> x.field === "errorCount")!.width = 120
    columns.find(x=> x.field === "status")!.renderCell = renderStatus
    columns.find(x=> x.field === "run")!.renderCell = runTask
    // MUI X v7+ valueGetter receives (value, row, column, apiRef) directly
    columns.find(x=> x.field === "lastRun")!.valueGetter = (value: any) => value ? new Date(value).toLocaleString("he") : ""
    columns.find(x=> x.field === "nextRun")!.valueGetter = (value: any) => value ? new Date(value).toLocaleString("he") : ""
}

setStoreAndColumns();

export const TasksContainer = () => {

    return (
        <Paper sx={{margin: "20px 0", borderRadius: "16px", boxShadow: 'none'}} elevation={5}>
        <GenericItemsForm
            columns={columns}
            store={store}
            breadcrumbs={{
                link: urlsService.tasks(),
                text: "Tasks Dashboard",
                icon: <HomeOutlined />
            }}
            getAllParams={getParams}
            createButton={{
                to: urlsService.createTask(),
                text: "CREATE Task"
            }}
        tableProps={{pageSize: 100, style: {minHeight: "75vh"}}}/>
        </Paper>
    );
};